export default __webpack_public_path__ + "static/media/map-gold-icon.8fc1cd59.svg";